<div
  [ngClass]="{
    'track-actions': true,
    'track-actions--column': direction === 'column'
  }"
>
  <div
    [ngClass]="{
      'track-actions__controls': true,
      'track-actions__controls--column': direction === 'column'
    }"
  >
    <!-- Like button -->
    @if (showLikeBtn && isBeat) {
      <bmcore-like-btn
        [showLikesCount]="showLikesCount"
        [likeStatus]="track.userLike"
        [likesCount]="track.likesCount"
        [iconSize]="16"
        [beatId]="track.id"
      ></bmcore-like-btn>
    }

    <!-- Favourite button -->
    @if (showFavouriteBtn && isBeat) {
      <bmcore-fav-btn
        [track]="track"
        [showIconBtnVariant]="showIconBtnVariant"
        [iconButtonSize]="iconButtonSize"
        [iconSize]="iconSize"
      ></bmcore-fav-btn>
    }

    <!-- Download button -->
    @if (isBeat) {
      <bmcore-download-btn
        [demoDownloading]="track.demoDownloading"
        [downloadMp3Url]="track.mp3"
        [iconSize]="iconSize"
        [trackId]="track.id"
        [showIconBtnVariant]="showIconBtnVariant"
      ></bmcore-download-btn>
    }

    <!-- Share button -->
    @if (showShareBtn && (isFreeBeat || isBeat)) {
      <bmcore-share-btn
        [track]="track"
        [showIconBtnVariant]="showIconBtnVariant"
        [iconButtonSize]="40"
        [iconSize]="iconSize"
      ></bmcore-share-btn>
    }

    <!-- Volume control button -->
    <ng-content select="bmcore-player-volume-control"></ng-content>
  </div>

  <!-- Buy button -->
  @if (isBeat) {
    <bmcore-button
      [ngClass]="{ 'track-actions--main-btn': direction === 'row' }"
      [themeBtnClass]="isTrackInCart ? 'theme-btn__player-btnGoToCart' : 'theme-btn__player-btnBuy'"
      [themeIconClass]="isTrackInCart ? 'theme-icon__player-btnIconGoToCart' : 'theme-icon__player-btnIconBuy'"
      [title]="buyBtnText"
      [mobMode]="showBuyBtnMobMode"
      [styleName]="isTrackInCart ? 'in cart' : 'track'"
      [routerPath]="buyBtnRouterPath"
      (clickHandler)="buyBtnClickEvent.emit($event)"
    >
      <bmcore-cart-icon [width]="iconSize" [height]="iconSize"></bmcore-cart-icon>
    </bmcore-button>
  }

  <!-- Download a free beat button -->
  @if (isFreeBeat && track.demoDownloading) {
    <bmcore-button
      [ngClass]="{ 'track-actions--main-btn': direction === 'row' }"
      [themeBtnClass]="isTrackInCart ? 'theme-btn__player-btnGoToCart' : 'theme-btn__player-btnBuy'"
      [themeIconClass]="isTrackInCart ? 'theme-icon__player-btnIconGoToCart' : 'theme-icon__player-btnIconBuy'"
      [title]="showDownloadFreeBeatText && lg.button.download"
      [styleName]="'track'"
      [routerPath]="freeBeatPageUrl"
    >
      <bmcore-download-icon [width]="iconSize" [height]="iconSize"></bmcore-download-icon>
    </bmcore-button>
  }
</div>
